<template>
  <div>
    <div v-show="status != 0" style="font-size: 16px;">
      <span v-show="name.length == 1" style="font-weight: bolder;">【{{ name[0] }}】</span>
      <span v-show="status == 1">服務款項尚未入帳；如果您已繳款，請致電客服中心重新開通使用。</span>
      <span v-show="status == 2">服務訂閱已結束；如需重新續訂，請致電客服中心。您的資料將於 <span style="color: #EC0000;">{{ date }}</span> 被刪除。</span>
      <span v-show="status == 3">服務訂閱已結束；目前無法使用此功能，如需重新續訂，請致電客服中心。</span>
      <el-popover
        v-show="name.length > 1"
        placement="bottom"
        width="auto"
        trigger="click"
        >
          <div style="font-size: 16px;">
            <div style="display: flex;justify-content: center;">
              <p v-if="status == 1">未入帳的服務訂閱</p>
              <p v-else>已結束的服務訂閱</p>
            </div>
            <ul>
              <li v-for="(item, index) in name" :key="index">{{ item }}</li>
            </ul>
          </div>
        <u slot="reference" style="cursor: pointer;color: #FF8A00;">詳情</u>
      </el-popover>
    </div>
  </div>
</template>
<script>
  var moment = require('moment')
  export default {
    name: 'serviceProvideMsg',
    props: {
      name: {
        type: Array,
        default: () => ['服務']
      },
      status: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        date: moment().format('yyyy-MM-DD 23:59:00')
      }
    }
  }
</script>